/**
 * The one thing Tailwind utilities cannot express here: the timeline's
 * hairline markers, which need a hit area wider than the 2px the eye sees.
 *
 * This file used to also carry a hand-rolled TeX renderer's boxes and a second
 * markdown stylesheet, because the admin panel had its own question renderer.
 * It no longer does — admin and student both render through
 * `@/lib/markdown`, so the typography lives in `lib/markdown/markdown.css`.
 *
 * It lives in a `<style>` tag rather than in `apps/web/src/styles.css` because
 * that file is shared scaffold. Every value below is a design token — no new
 * colors, no new radii, nothing above 6px.
 */

const CSS = `
/* ------------------------------------------------------ timeline ---- */
.tl-marker { position: absolute; top: 0; bottom: 0; width: 2px; margin-left: -1px; }
.tl-marker::after {
  /* A wider invisible hit area than the 2px the eye sees. */
  content: "";
  position: absolute;
  top: 0; bottom: 0; left: -4px; right: -4px;
}
`;

export function AdminStyles() {
  return <style>{CSS}</style>;
}
